import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.c35gM5',
    defaultMessage: 'Roles',
  },
  members: {
    id: 'studio.+a+2ug',
    defaultMessage: 'Members',
  },
  addMembers: {
    id: 'studio.OCiHj6',
    defaultMessage: 'Add members',
  },
  member: {
    id: 'studio.7L86Z5',
    defaultMessage: 'Member',
  },
  role: {
    id: 'studio.c35gM5',
    defaultMessage: 'Roles',
  },
  noMembers: {
    id: 'studio.jRZz4r',
    defaultMessage: 'This app currently has no members.',
  },
  memberError: {
    id: 'studio.zCFjlf',
    defaultMessage: 'Something went wrong when trying to load the list of members.',
  },
  loadingMembers: {
    id: 'studio.Lxkny3',
    defaultMessage: 'Loading members…',
  },
  membersError: {
    id: 'studio.Aopgs7',
    defaultMessage: 'There was a problem loading the members of this app.',
  },
  properties: {
    id: 'studio.aI80kg',
    defaultMessage: 'Properties',
  },
  export: {
    id: 'studio.kM6XaM',
    defaultMessage: 'Export to CSV',
  },
  notAllowed: {
    id: 'studio.kznIRT',
    defaultMessage: 'You don’t have sufficient permissions to invite members.',
  },
  demo: {
    id: 'studio.TPv/Zv',
    defaultMessage: 'Demo',
  },
  actions: {
    id: 'studio.wL7VAE',
    defaultMessage: 'Actions',
  },
});
